import React from 'react';
import { UIWindowModal } from '../modals';
import { useLang } from '../../../_LangContext';
import Utils from '../../../_Utils';

const ModalMapAlert = ({ isOpen, onClose, messageData }) =>
{
	const { getMessage } = useLang();
	const alertClassName = messageData?.className ? `alert ${messageData.className}` : 'alert';
	
	// Get message from locale using the key
	const message = messageData?.key ? getMessage(messageData.key) : '';

	return (
		<UIWindowModal className={alertClassName} isOpen={isOpen} onClose={onClose}>
			<div className="modal-container">
				<div className="modal-container-inner">
					<div className="alert-content">
						{messageData?.img ? (
							<div className="alert-image">
								<img src={`${process.env.PUBLIC_URL}/img/${messageData.img}`} />
							</div>
						) : (
							<div className="alert-icon">
								<p className="icon exclamation" />
							</div>
						)}
						{message && (
							<div className="message" dangerouslySetInnerHTML={{ __html: Utils.toBR(message) }} />
						)}
					</div>
				</div>
			</div>
		</UIWindowModal>
	);
};

export default ModalMapAlert;
